<h2 mat-dialog-title>An error has occured!</h2>

<mat-dialog-content>
  <p>{{ data.message }}</p>
  @if(data.message2) {
    <p>{{ data.message2 }}</p>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close]>Ok</button>
</mat-dialog-actions>
